import {Hidden, HiddenProps} from './Hidden'

export {Hidden} from './Hidden'
export type {HiddenProps}
export default Hidden
